export function isAHWStore(id: string): boolean {
  return id === "Store_ckuqkzb7701u001jf724jhmgm";
}
